export default "/images/ic-phone.svg?bdc4e28b54a2ee7cda6ad3ba1baa6127";